const prefix = 'existing-user-password-form';

export default {
  Password: `${prefix}__password`,
  SubmitButton: `${prefix}__link-account-button`,
  GoBackButton: `${prefix}__go-back-button`,
  ForgotPasswordButton: `${prefix}__forgot-password-button`
};
